import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useActionDispatcher } from '../../../hooks';
import { Button, Modal } from '../../../components';
import yup from '../../../utility/yup';
import InvoiceCreateForm from './InvoiceCreateForm';
import { createNewInvoiceRequest } from '../../../store/modules/billing/actions';
import { selectCreateCustomInvoiceLoading } from '../../../store/modules/billing/selectors';
import useStyles from './styles';

type Props = {
  userId: number;
};

const invoiceSchema = yup.object().shape({
  project_id: yup.number().integer(),
  product_line_items: yup.array().of(
    yup.object().shape({
      quantity: yup.number().typeError('Quantity must be a number')
        .min(0, 'Quantity must be greater than or equal to 0'),
    }),
  ),
  custom_line_items: yup.array().of(
    yup.object().shape({
      amount: yup.number().typeError('Amount must be a number').required().label('Amount'),
      title: yup.string().when('amount', {
        is: 0,
        then: yup.string(),
        otherwise: yup.string().required().label('Title'),
      }),
    }),
  ),
  promotion_code: yup.string().trim().min(8).max(12)
    .matches(
      /^.[a-zA-Z0-9]+$/,
      {
        message: 'Only alphanumeric characters',
        excludeEmptyString: true,
      },
    ),
  public_note: yup.string().trim(),
  private_note: yup.string().trim(),
  charge_immediately: yup.boolean(),
});

const InvoiceCreate = ({ userId }: Props) => {
  const classes = useStyles();

  const initialValues = useMemo(() => ({
    user_id: userId,
    charge_immediately: true,
    private_note: '',
    public_note: '',
    promotion_code: '',
    project_id: -1,
    product_line_items: [
      {
        product_code: 'product-video-edit-primary',
        quantity: 0,
        project_id: -1,
      },
      {
        product_code: 'product-video-additional-min',
        quantity: 0,
        project_id: -1,
      },
    ],
    custom_line_items: [
      {
        title: '',
        amount: 0,
      },
      {
        title: '',
        amount: 0,
      },
    ],
  }), [userId]);

  const loading = useSelector(selectCreateCustomInvoiceLoading);

  const [isOpenModal, setIsOpenModal] = useState(false);

  return (
    <>
      <Button styleButton="orange" onClick={() => setIsOpenModal(true)}>
        Create Invoice
      </Button>

      <Modal
        form={{
          data: initialValues,
          validationSchema: invoiceSchema,
          onSubmit: useActionDispatcher(createNewInvoiceRequest),
          submitTitle: 'Create',
          loading,
          formStyles: classes.formInvoice,
        }}
        paperClassName={classes.invoiceModal}
        open={isOpenModal}
        onCloseHandler={() => setIsOpenModal(false)}
        title="Create Manual Invoice"
      >
        <InvoiceCreateForm />

      </Modal>
    </>
  );
};

export default InvoiceCreate;
